function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import RESTSerializer, { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
export default class Menu extends RESTSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      menuHours: {
        embedded: 'always'
      }
    });
  }
  keyForAttribute(attr) {
    return underscore(attr);
  }
  modelNameFromPayloadKey() {
    return 'menu-sync/menu';
  }
  serializeIntoHash(hash, type, record, options) {
    super.serializeIntoHash(hash, type, record, options);

    // eslint-disable-next-line no-param-reassign
    hash.menu = hash['menuSync/menu'];

    // eslint-disable-next-line no-param-reassign
    delete hash['menuSync/menu'];
  }
}